import moment from 'moment';
import { ConfigInstanceToken } from '../../interfaces/config.interface';
import { CompositeModel } from '../../models/complex/composite.model';
import { TimeUtilities } from '../../utilities/time-utilities';
import { CustomInjector } from '../custom-injector/custom-injector';
import { SoftwareLicenceState } from '../../state/software-licences';

export class SoftwareLicenceModel extends CompositeModel {
    public materialNumber: string;
    public serialNumber: string;
    public description: string;
    public startDate: moment.Moment;
    public endDate: moment.Moment;
    public status: string;
    public constructor(softwareLicence: ODataSoftwareLicenceSet) {
        super('SoftwareLicenceModel', {});
        const injector = CustomInjector.getInjector();
        const configService = injector.get(ConfigInstanceToken);
        this.materialNumber = softwareLicence.Material;
        this.serialNumber = softwareLicence.SerialNo;
        this.description = softwareLicence.Description;
        this.status = softwareLicence.Status;

        const formatMomentInUtc = configService.getFormatMomentInUTC();
        this.startDate = softwareLicence.StartDate
            ? TimeUtilities.momentFromDateAndTime(softwareLicence.StartDate, '', formatMomentInUtc)
            : moment.invalid();
        this.endDate = softwareLicence.EndDate
            ? TimeUtilities.momentFromDateAndTime(softwareLicence.EndDate, '', formatMomentInUtc)
            : moment.invalid();
    }

    public static fromOData(data: ODataSoftwareLicenceSet): SoftwareLicenceModel {
        return new SoftwareLicenceModel(data);
    }

    public static fromState(plainSoftwareLicence: SoftwareLicenceState): SoftwareLicenceModel {
        return new SoftwareLicenceModel({
            Material: plainSoftwareLicence.materialNumber,
            SerialNo: plainSoftwareLicence.serialNumber,
            Description: plainSoftwareLicence.description,
            StartDate: plainSoftwareLicence.startDate,
            EndDate: plainSoftwareLicence.endDate,
            Status: plainSoftwareLicence.status,
        });
    }
}

export interface ODataSoftwareLicenceSet {
    Material: string;
    SerialNo: string;
    Description: string;
    StartDate: string | null;
    EndDate: string | null;
    Status: string;
}
